/* eslint-disable react/prop-types */
import classes from './HeaderSlider.module.scss' ;
import {useState , useEffect} from 'react' ;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome' ;
import { faAnglesRight , faAnglesLeft} from '@fortawesome/free-solid-svg-icons' ;
import {Link} from 'react-router-dom' ;
import {products} from '../Data/products' ;
import {linkToProduct} from '../Data/ProductsDetails' ;

let products_ = products.map(product =>{
    return {...product,to : linkToProduct(product.title_2?product.title_2:product.title)}
});
function HeaderSlider() {
    //---------------------------------------------------
    const [next , setIndex] = useState({index : 0 , after : true, before : false}) ;
    const [direction , setDirection]= useState('forward') ;
    const [updated , setUpdated]= useState(false) ;
    useEffect(() => {
        if(next.after&&(!next.before)){
            setDirection('forward')
        }
        if(!next.after&&(next.before)){
            setDirection('backward')
        }
    },[next.after,next.before])
    //---------------------------                
    useEffect(() => {
        const interval = setInterval(() => {
            if(direction === 'forward'){
                increaseIndexHandler()
            }else if (direction === 'backward'){
                decreaseIndexHandler()
            }
        }, 10000);
        return () => clearInterval(interval);
    }, [direction]);
    //---------------------------------------------
    useEffect(() => {
        setUpdated(true);
        const timer =  setTimeout(() => {
            setUpdated(false)
        }, 2500);
        return () => clearTimeout(timer);
    }, [next.index]);
    //-----------------------
    const increaseIndexHandler = () => {
        setIndex((prev=> {
            if(prev.index + 1 === products_.length -1) {
                return {index : prev.index + 1 ,after : false , before : true};
            }else if(prev.index  === products_.length  -1){  
                return 
            }else {
                return { index : prev.index + 1 ,after : true , before : true};
            }
        }))
        setUpdated(false);
    }
    //------------------------
    const decreaseIndexHandler = () => {
        setIndex((prev=> {
            if(prev.index - 1 === 0 ) {
                return {index : prev.index - 1 , after : true , before : false};
            }else if(prev.index === 0){   return
            }else { 
                return { index : prev.index - 1 ,after : true , before : true};
            }
        }))
        setUpdated(false);
    }
    // props.onChangeCategory(products_[next.index].name) ;
    //------------------------
    return (
        // <header style={{backgroundImage: `url(${products_[next.index].img})`,}}>
        <section className={classes['section__container']}>
            <p className={classes["section__subheader"]}>Our Solutions</p>
            <h2 className={classes["__strong"]}>Complete set of software solutions for ultimate management of the healthcare organization</h2>
            {/* --------------------  slider         ------------------- */}
            <main className={`${classes.main_}`}>
                <div className={`${classes.imgCon}`}>
                    <img src={products_[next.index].img} alt="BG IMG" className={`${updated ? classes.imgIntro : null}`} loading="lazy"/>
                </div>
                {/* <div className={classes["container__2"]}> */}
                    <div className={`${classes["main__container"]}`}>
                        <button className={`${classes.beforeC}`}onClick={decreaseIndexHandler} disabled={!next.before}> 
                            <FontAwesomeIcon className={`${classes.before}`}  icon={faAnglesLeft} />
                        </button>
                        <div className={classes["typography"]}>
                            <h1 className={`${updated ? classes.imgIntro : null}`}>{products_[next.index].title}</h1>
                            <p className={`${updated ? classes.imgIntro : null}`}>{products_[next.index].description}</p>
                        </div>
                        <button className= {`${classes.afterC}`} onClick={increaseIndexHandler} disabled={!next.after}>
                            <FontAwesomeIcon className={`${classes.after}`}  icon={faAnglesRight}/> 
                        </button>
                        <Link to={products_[next.index].to} className={`${updated ? classes.imgIntro : null} ${classes['product___btn']}`}>Read More</Link>
                        <div className={`${classes.dots}`}>
                        {products_.map((m,i)=>{return ((<span key={i} className={`${i ===next.index? classes.active : null}`}  onClick={()=>{setUpdated(false); setIndex({index : i,after:i=== products_.length -1?false:true ,before:i===0?false:true })}}></span>))})}
                        </div>
                    </div>
                {/* </div> */}
            </main>
            {/* --------------------  slider         ------------------- */}
        </section>
    )
}

export default HeaderSlider
